import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Flex, Link, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";

interface Props {
  permissions: Permiso[]; 
}

export const RolesView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseRoleAssignation =
    hasAccess(PermissionCode.ROLE_ASSIGNATION);
  const canUseRoleList =
    hasAccess(PermissionCode.ROLES_PERMISSIONS);
  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseRoleAssignation && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.USER_ROLES)}>
          <Text
            fontWeight={500}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            Asignar roles y sucursales
          </Text>
        </Link>
      )}
      {canUseRoleList && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.ROLES)}>
          <Text
            fontWeight={500}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            Roles
          </Text>
        </Link>
      )}
    </Flex>
  );
};
